export default "__VITE_ASSET__7071a2c5__"